module.exports = __webpack_public_path__ + "static/media/crecimiento_card_detail.f454ec31.png";